import { library } from '@fortawesome/fontawesome-svg-core';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

// Import the icons needed from the main library
import {
  faPlus,
  faCogs,
  faCircle,
  faQuestionCircle,
  faXmark,
  faEye,
  faPalette,
  faChevronLeft,
  faCircleChevronLeft,
  faBookOpenReader,
  faComment,
  faCircleChevronDown,
  faTrash,
  faCircleChevronUp,
  faTrashCan,
  faCircleCheck,
  faEyeSlash,
  faThumbsUp,
  faEllipsis,
  faFaceSmile,
  faEnvelopesBulk,
  faRightLong,
  faFaceGrin,
  faExclamation,
  faPaperPlane,
  faTextHeight,
  faInfo,
  faFileLines,
  faTriangleExclamation,
  faUserLock,
  faUserPlus,
  faUserAstronaut,
  faThumbtack,
  faSquarePollVertical,
} from '@fortawesome/free-solid-svg-icons';
import { faDownload } from '@fortawesome/free-solid-svg-icons/faDownload';
import { faLink } from '@fortawesome/free-solid-svg-icons/faLink';

library.add(
  faPlus,
  faCogs,
  faCircle,
  faQuestionCircle,
  faXmark,
  faEye,
  faPalette,
  faChevronLeft,
  faCircleChevronLeft,
  faBookOpenReader,
  faComment,
  faCircleChevronDown,
  faTrash,
  faCircleChevronUp,
  faTrashCan,
  faCircleCheck,
  faEyeSlash,
  faThumbsUp,
  faEllipsis,
  faFaceSmile,
  faEnvelopesBulk,
  faRightLong,
  faFaceGrin,
  faExclamation,
  faPaperPlane,
  faTextHeight,
  faInfo,
  faFileLines,
  faTriangleExclamation,
  faUserLock,
  faUserPlus,
  faUserAstronaut,
  faThumbtack,
  faSquarePollVertical,
  faDownload,
  faLink,
);

export default FontAwesomeIcon;
